export * from './sGKC006A.service';
import { SGKC006AService } from './sGKC006A.service';

export * from './sGKC007A.service';
import { SGKC007AService } from './sGKC007A.service';

export * from './sGKC008A.service';
import { SGKC008AService } from './sGKC008A.service';

export * from './sGKC009A.service';
import { SGKC009AService } from './sGKC009A.service';

export * from './sGKC010A.service';
import { SGKC010AService } from './sGKC010A.service';

export * from './sGKC011A.service';
import { SGKC011AService } from './sGKC011A.service';

export * from './sGKC012A.service';
import { SGKC012AService } from './sGKC012A.service';

export * from './sGKC015A.service';
import { SGKC015AService } from './sGKC015A.service';

export * from './sGKC016A.service';
import { SGKC016AService } from './sGKC016A.service';

export * from './sGKC019A.service';
import { SGKC019AService } from './sGKC019A.service';

export * from './sGKC021A.service';
import { SGKC021AService } from './sGKC021A.service';

export * from './sGKC024A.service';
import { SGKC024AService } from './sGKC024A.service';

export * from './sGKC026A.service';
import { SGKC026AService } from './sGKC026A.service';

export * from './sGKC027A.service';
import { SGKC027AService } from './sGKC027A.service';

export * from './sGKC028A.service';
import { SGKC028AService } from './sGKC028A.service';

export * from './sGKC029A.service';
import { SGKC029AService } from './sGKC029A.service';

export * from './sGKC030A.service';
import { SGKC030AService } from './sGKC030A.service';

export const APIS = [
    SGKC006AService,
    SGKC007AService,
    SGKC008AService,
    SGKC009AService,
    SGKC010AService,
    SGKC011AService,
    SGKC012AService,
    SGKC015AService,
    SGKC016AService,
    SGKC019AService,
    SGKC021AService,
    SGKC024AService,
    SGKC026AService,
    SGKC027AService,
    SGKC028AService,
    SGKC029AService,
    SGKC030AService
];